/* Goloka V3 product page: "Pairs well with" loader and the sticky mobile buy bar. */
(function () {
  /* ---------- Pairs well with ---------- */
  if (!customElements.get('v3-pairs')) {
    customElements.define(
      'v3-pairs',
      class V3Pairs extends HTMLElement {
        connectedCallback() {
          if (this.querySelector('[data-v3-pairs-list]')) return;
          this.observer = new IntersectionObserver(
            (entries, obs) => {
              if (!entries[0].isIntersecting) return;
              obs.disconnect();
              this.load();
            },
            { rootMargin: '0px 0px 400px 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        async fetchIntent(intent) {
          const params = new URLSearchParams({
            product_id: this.dataset.productId,
            limit: this.dataset.limit || '3',
            intent: intent,
            section_id: this.dataset.sectionId,
          });
          const res = await fetch(this.dataset.url + '?' + params.toString());
          if (!res.ok) return null;
          const wrap = document.createElement('div');
          wrap.innerHTML = await res.text();
          const found = wrap.querySelector('v3-pairs');
          return found && found.querySelector('[data-v3-pairs-list]') ? found.innerHTML : null;
        }

        async load() {
          try {
            // Merchant-curated complementary products first, then the related fallback.
            const html = (await this.fetchIntent('complementary')) || (await this.fetchIntent('related'));
            if (html) this.innerHTML = html;
          } catch (e) {
            console.error(e);
          }
        }
      }
    );
  }

  /* ---------- Sticky mobile buy bar ---------- */
  function initBar(bar) {
    if (bar.dataset.v3Ready) return;
    var targetId = bar.dataset.target;
    var first = document.getElementById(targetId);
    if (!first) return;
    function getTarget() { return document.getElementById(targetId) || first; }
    bar.dataset.v3Ready = '1';
    bar.hidden = false;

    var btn = bar.querySelector('[data-v3-buybar-btn]');
    var priceEl = bar.querySelector('[data-v3-buybar-price]');
    var anchor = first.closest('.product-form__buttons') || first;
    var formHost = (first.closest('product-form') || first).parentElement;

    function syncButton() {
      var target = getTarget();
      var disabled = target.hasAttribute('disabled') || target.getAttribute('aria-disabled') === 'true';
      var label = target.querySelector('span');
      btn.disabled = target.hasAttribute('disabled');
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      if (label && label.textContent.trim()) btn.textContent = label.textContent.trim();
    }
    function syncPrice() {
      var box = document.getElementById(bar.dataset.priceId);
      if (!box || !priceEl) return;
      var price = box.querySelector('.price');
      if (!price) return;
      var el = price.classList.contains('price--on-sale')
        ? price.querySelector('.price-item--sale')
        : price.querySelector('.price-item--regular');
      if (el && el.textContent.trim()) priceEl.textContent = el.textContent.trim();
    }

    btn.addEventListener('click', function () {
      var target = getTarget();
      if (target.hasAttribute('disabled') || target.getAttribute('aria-disabled') === 'true') return;
      target.click();
    });

    new MutationObserver(syncButton).observe(formHost, { attributes: true, childList: true, subtree: true, characterData: true });
    var priceBox = document.getElementById(bar.dataset.priceId);
    if (priceBox) new MutationObserver(syncPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });
    syncButton();
    syncPrice();

    // Only "scrolled past" counts: a button still below the fold must not trigger the bar.
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
    io.observe(anchor);
  }

  function boot() {
    document.querySelectorAll('[data-v3-buybar]').forEach(initBar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
